<template>
  <div style="width: 70%">
    <b-loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></b-loading>
    <form>
      <b-field :message="[{
                        'You need to choose a pack': errorPackName,
                        'There are not enough activities in this pack for your map' : errorPackLength,
                        'This pack has enough activities for your map': okPackLength
                     }]" :type="{
                        'is-danger': errorPackName,
                        'is-danger': errorPackLength,
                        'is-success': okPackLength,
                     }"
               horizontal
               label="Find a pack:">
        <b-autocomplete
            v-model="packName"
            :data="filteredPackByName"
            :keep-first="true"
            :loading="isLoading"
            :open-on-focus="true"
            clearable
            field="name"
            placeholder="e.g. Sports"
            @select="option => packSelected(option)">

          <template slot-scope="props">
            <div class="media">
              <div class="media-content">
                <b>{{ props.option.name }} -
                  {{ props.option.rawActivityIds ? props.option.rawActivityIds.length : 0 }}
                  activities</b>
                <br>
                <small>{{ props.option.description }}</small>
                <br>
                <b-taglist>
                  <b-tag
                      v-for="(age, index) in props.option.suitableFor"
                      :key="index"
                      type="is-warning">{{ age }}
                  </b-tag>
                </b-taglist>
              </div>
            </div>
          </template>
        </b-autocomplete>
      </b-field>

      <map-previewer v-if="isMapVisible"
                     ref="map_previewer"
                     :center="center"
                     :mapType="mapType"
                     :markers="markers"
                     height="400"
                     style="padding-top: 20px"></map-previewer>

      <p v-if="isMapVisible" style="margin-top: 20px; font-weight: bold">Drag and drop rows to reorder activities. You
        can also
        shuffle the activities to randomly assign an order to your game.
        <br/>The greyed lines are not taken into account in the game.</p>

      <raw-activities-random-table
          v-if="isMapVisible"
          :max-lines-selected="markers.length - 1"
          :random-raw-activities="randomRawActivities"
          :shuffle-display="true"
          :detailed="tableDetails"
          @shuffled="shuffleActivitiesNew"
      ></raw-activities-random-table>
    </form>
  </div>
</template>

<script>
import _ from 'lodash'
import MapPreviewer from '../single/MapPreviewer'
import packService from '../../services/packService'
import displayHelper from '../../helpers/display-helper'
import BImg from '../single/BImg'
import RawActivitiesRandomTable from '../single/RawActivitiesRandomTable'
import constantHelper from '@/enums/constants'
import gameStylesHelper from '@/enums/gameStyles'

export default {
  components: {
    MapPreviewer,
    BImg,
    RawActivitiesRandomTable,
  },
  props: {
    game: {},
    next: false,
    isEdit: false,
  },
  computed: {
    filteredPackByName() {
      if (!this.packs) {
        return []
      }
      return this.packs.filter((option) => {
        let gameMarkers = true

        if (this.game && this.game.map && this.game.map.markers) {
          if (option.rawActivityIds) {
            gameMarkers = (option.rawActivityIds.length >= this.game.map.markers.length)
          }
        }

        if ((option.name) && (option.description) && (option.rawActivityIds)) {
          return ((option.name
                      .toString()
                      .toLowerCase()
                      .indexOf(this.packName.toLowerCase()) >= 0) ||
                  (option.description
                      .toString()
                      .toLowerCase()
                      .indexOf(this.packName.toLowerCase()) >= 0)) &&
              (gameMarkers)
        }
      })
    }
  },
  data() {
    return {
      isLoading: false,
      packs: [],
      packName: '',
      packId: '',
      selectedPack: null,
      hasError: false,

      isMapVisible: false,

      errorPackName: false,
      errorPackLength: false,
      okPackLength: false,

      center: {lat: 1.3581036, lng: 103.8329625},
      markers: [],
      mapType: 'satellite',

      defaultImgSrc: '',

      randomRawActivities: [],

      warningAccepted: false,
      tableDetails: true,

    }
  },
  created() {
    this.isLoading = true
    this.defaultImgSrc = constantHelper.GENERIC_PHOTO_URL

    this.loadPacksList()

    if (this.isEdit) {
      this.packName = this.game.chosenPack ? this.game.chosenPack.packName : ''
      this.packId = this.game.chosenPack ? this.game.chosenPack.packId : ''

      this.loadRawActivitiesList()

      this.markers = this.game.map.markers
      this.isMapVisible = !!this.game.chosenPack
      this.okPackLength = !!this.game.chosenPack
    } else {
      if (this.game) {
        if (this.game.chosenPack) {
          this.warningAccepted = true

          this.packName = this.game.chosenPack.packName ? this.game.chosenPack.packName : ''
          this.packId = this.game.chosenPack.packId ? this.game.chosenPack.packId : ''

          if (this.game.map) {
            this.markers = this.game.map.markers ? this.game.map.markers : []
            this.isMapVisible = true
            this.okPackLength = true

            this.loadRawActivitiesList()
          }
        }
      }
    }
  },
  watch: {
    'next': function (next) {
      if (next) {
        if (!this.validateFields()) {
          console.log('Errors in fields')
          this.$emit('errors')
          return
        }

        // barycenter of all points (approx)
        let avg = [0, 0]

        // automatic mode
        let associationMarkersActivities = []
        for (let i = 0; i < this.markers.length; i++) {
          avg[0] += this.markers[i].position.lat
          avg[1] += this.markers[i].position.lng

          let activityToCopy = _.cloneDeep(this.randomRawActivities[i])

          delete activityToCopy.tenantId
          activityToCopy.position = this.markers[i].position

          associationMarkersActivities.push(activityToCopy)
        }

        const step3Game = {
          chosenPack: { // empty if manual
            packId: this.packId,
            packName: this.packName
          },
          associationMarkersActivities,
          initialGeolocation: {
            lat: avg[0] / this.markers.length,
            lng: avg[1] / this.markers.length,
            zoom: 15,
          }
        }
        console.log('Before emit in Next Step 3')
        this.$emit('updated', step3Game)
      }
    }
  },
  methods: {
    loadPacksList() {
      var parent = this
      packService.getPacks()
          .then(packs => {
            this.packs = packs
            this.isLoading = false
          })
          .catch((err) => {
            displayHelper.displayError(parent, 'Oops.. An error occurred: ' + err.message)
          })
    },
    packSelected(option) {
      if (this.errorPackName) {
        this.errorPackName = false
      }
      if (this.errorPackLength) {
        this.errorPackLength = false
      }
      if (this.okPackLength) {
        this.okPackLength = false
      }

      if (option) {
        // test if changing option
        if (this.game && this.game.chosenPack) {
          if (this.game.chosenPack.packId !== option.packId) {
            // new pack selected, needs to reshuffle the activities
            delete this.game.associationMarkersActivities
          }
        }

        if (option.rawActivityIds) {
          // the pack has associated activities
          if (option.rawActivityIds.length < this.game.map.markers.length) {
            // KO: not enough activities => errors
            this.isMapVisible = false
            this.errorPackLength = true
          } else {
            // OK: enough activities
            this.okPackLength = true
            this.markers = this.game.map.markers
            this.packId = option.packId
            this.isMapVisible = true
            this.loadRawActivitiesList()
          }
        } else {
          // KO: no activities in the pack
          this.isMapVisible = false
          this.errorPackName = true
        }
        return true
      }
    },
    loadRawActivitiesList() {
      this.isLoading = true
      const parent = this
      const packId = this.packId
      packService.getAllRawActivitiesForPack(packId, false)
          .then((data) => {
            if (this.isEdit) {
              this.randomRawActivities = this.game.associationMarkersActivities
            } else {
              if (!this.game.associationMarkersActivities) {
                // normal case: activities are reshuffled for a new pack
                this.shuffleActivities(data)
              } else {
                // this will happen when the button BACK is pressed - no reshuffle but force to redraw the table
                this.randomRawActivities = _.uniqBy(_.concat(this.game.associationMarkersActivities, data), 'rawActivityId')
              }
            }
            this.isLoading = false
          })
          .catch((err) => {
            console.error(err)
            displayHelper.displayError(parent, 'Error fetching the activities: ' + err.message)
            this.isLoading = false
          })
    },
    validateFields() {
      if (!this.okPackLength) {
        displayHelper.displayError(this, 'Sorry, you need to assign activities before you move to the next step')
        return false
      }

      let warning = false
      let warningArray = []

      for (let i = 0; i < this.markers.length; i++) {
        if (this.isWarningForChainedGameWithFreeTextAndUnlimitedAnswers(this.randomRawActivities[i])) {
          warningArray.push(i + 1)
          warning = true
        }
      }

      warning = warning && this.game.gameStyle === gameStylesHelper.GAME_STYLES.CHAINED_MODE

      if (warning) {
        if (this.warningAccepted) {
          console.log('bypassing')
          return true
        }

        this.$buefy.dialog.confirm({
          title: 'Warning - deadlock detected',
          message: 'You have selected one or more free-text challenges with unlimited answers in a Chained Mode game style.<br/><br/>' +
              'Challenges <b>#' + _.join(warningArray, ', ') + '</b> should be deselected.<br/><br/>' +
              '<b>This could irremediably block players.</b><br/><br/>' +
              'Are you sure you want to continue?',
          confirmText: 'I understand',
          type: 'is-danger',
          hasIcon: true,
          onConfirm: () => {
            this.warningAccepted = true
          }
        })

        return false
      }

      return true
    },
    shuffleActivities(data) {
      this.randomRawActivities = _.shuffle(data)
      this.warningAccepted = false
    },
    shuffleActivitiesNew(rawActivities) {
      this.warningAccepted = false
      this.randomRawActivities = rawActivities
    },
    getClassForOverMarkers(i) {
      if (i > this.markers.length - 1) {
        return 'is-gris'
      }
    },
    getImageBackground(img) {
      return 'background-image:url(' + img ? img : this.defaultImgSrc + ');'
    },
    isWarningForChainedGameWithFreeTextAndUnlimitedAnswers(activity) {
      return !!activity.content.type && activity.content.type === 'free-text' &&
          !!activity.allowedAttempts
    }
  }
}
</script>
<style scoped>
.btn-margin {
  margin-left: 10px;
  margin-right: 10px;
}
</style>

<style>
tr.is-gris {
  background: #e8eff4;
  font-style: italic;
}
</style>
